import styled from '@emotion/styled'
import { DESIGN_TOKENS } from 'constants/color.constants'
import { pxToRem } from 'utils/rem.utils'

export const SpinnerSquare = styled.div`
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
            background-color: ${DESIGN_TOKENS.background.muted};
        }
        12.5% {
            transform: rotate(45deg);
            background-color: ${DESIGN_TOKENS.text.accentForeground};
        }
        25% {
            transform: rotate(90deg);
            background-color: ${DESIGN_TOKENS.background.muted};
        }
        37.5% {
            transform: rotate(135deg);
            background-color: ${DESIGN_TOKENS.text.accentForeground};
        }
        50% {
            transform: rotate(180deg);
            background-color: ${DESIGN_TOKENS.background.muted};
        }
        62.5% {
            transform: rotate(225deg);
            background-color: ${DESIGN_TOKENS.text.accentForeground};
        }
        75% {
            transform: rotate(270deg);
            background-color: ${DESIGN_TOKENS.background.muted};
        }
        87.5% {
            transform: rotate(315deg);
            background-color: ${DESIGN_TOKENS.text.accentForeground};
        }
        100% {
            transform: rotate(0deg);
            background-color: ${DESIGN_TOKENS.background.muted};
        }
    }

    width: ${pxToRem(14)};
    height: ${pxToRem(14)};
    animation: rotate 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    transition: background-color 0.15s ease-in-out;
`
